import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, TableHead, TableRow, TableCell } from "@material-ui/core";
import { notArrayOrEmpty } from '../../utils/helpers';
import guid from './../../utils/guid';
import { TooltipTop } from "./CustomTooltips";

const useStyles = makeStyles(theme => ({
    cell: {
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        fontSize: 14
    },
}));

const TableHeaderWithTooltip = ({ data, align = "center" }) => {
    const classes = useStyles();
    const printTable = data => {
        if (notArrayOrEmpty(data))
            return;
        return data.map(element => {
            return (
                <TooltipTop
                    key={guid()}
                    title={element.tooltipText}
                >
                    <TableCell
                        align={align}
                        className={classes.cell}
                    >
                        {element.icon ? element.icon : element.columnName }
                    </TableCell>
                </TooltipTop>
            );
        });
    };

    return (
        <TableHead>
            <TableRow>
                {printTable(data)}
            </TableRow>
        </TableHead>
    );
};

TableHeaderWithTooltip.propTypes = {
    data: PropTypes.array.isRequired,
    align: PropTypes.string
};

export default TableHeaderWithTooltip;
